module.exports = __webpack_public_path__ + "static/img/malaysia.d923ad2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/malaysia.jpg
// module id = MRud
// module chunks = 4